module.exports = __webpack_public_path__ + "static/scott-169548e61ab3144cc9b757185c10e118.jpg";